import { get } from '../../utility/Requests.default';

export const leaseUrl = '/api/license/accountant/Lease';

export function getAvailableTenantLeasesCount(): Promise<number> {
    return get<number>(leaseUrl);
}
